<h1 matDialogTitle
    class="title-container">
    {{'robot_versions_modal_title' | translate}}
</h1>

<mat-dialog-content class="machine-robot-versions">
    <p class="input">{{'robot_versions_modal_machine_name' | translate}}:
        <span class="input-value">{{context.data.name}}</span>
    </p>
    <ui-machine-robot-versions [machine]="context.data">
    </ui-machine-robot-versions>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button">
        {{ 'modal_action_close' | translate }}
    </button>
</mat-dialog-actions>
